enum SortOrders {
  ASC = 'Ascending',
  DESC = 'Descending',
}

enum TableVersion {
  ADMIN = 'ADMIN',
  WEB = 'WEB',
  DASHBOARD = 'DASHBOARD',
}

enum PaginationVersion {
  ADMIN = 'ADMIN',
  WEB = 'WEB',
}

export { SortOrders, TableVersion, PaginationVersion };
